//selectors MUST accept state as the first arguement
const bindSelectors = (slicer, selectors) => {
  const keys = Object.keys(selectors);
  const boundMethods = {};

  keys.forEach((k) => {
    boundMethods[k] = (fullState, ...args) => {
      return selectors[k](slicer(fullState), ...args);
    };
  });

  return boundMethods;
};

export default bindSelectors;
